import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { fmtMoeda } from '@/lib/utils/formatters';
import { useApuracaoSN } from '@/contexts';

export function RBT12Card() {
  const { dados, aguardandoPgdas } = useApuracaoSN();

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          RBT12 - Receita Bruta Acumulada
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {aguardandoPgdas && (
          <p className="text-xs font-medium text-amber-600">
            Sem dados suficientes — PGDAS não lido para este contribuinte.
          </p>
        )}
        <p className="text-3xl font-bold text-foreground">{fmtMoeda(dados.rbt12)}</p>

        <div className="space-y-1">
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Faixa Atual</span>
            <span className="font-medium">{dados.faixaAtual}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Limite da Faixa</span>
            <span className="font-medium">{fmtMoeda(dados.limiteFaixa)}</span>
          </div>
        </div>

        <div className="space-y-1.5">
          <Progress value={dados.percentualFaixa} className="h-2" />
          <p className="text-xs text-muted-foreground">
            {dados.percentualFaixa.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}% do limite
            da faixa
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
